module.exports = __webpack_public_path__ + "img/logo udegram.8eef23dc.svg";